import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import {CheckOutlined, DescriptionOutlined} from '@material-ui/icons';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import OutlinedButton from '../../../shared/buttons/OutlinedButton.tsx';
import TextButton from '../../../shared/buttons/TextButton.tsx';
import useCarregamentoPagina from '../../components/useCarregamentoPagina.js';
import useCreateFile from '../../../../hooks/useCreateFile.js';
import {salvarArquivoResposta} from '../../../../utils/download.js';
import {URL_INSCRICOES_ARQUIVOS_FICHA} from '../../../../constants/index.js';

const CORPO = {};

const useStyles = makeStyles(() => ({
    root: {
        width: 600,
        maxWidth: '100%'
    }
}));

/* Emissão da ficha de inscrição de uma inscrição (módulo CFGERFIINS): ficha final ou parcial. */
export default function DialogFichaInscricao(props) {
    const {open, onClose, inscricao} = props;
    const classes = useStyles();
    const [createFile, gerando] = useCreateFile({returnInnerLoadingState: true});

    // Geração do arquivo pelo LoadingModal global (sem spinner dentro do diálogo).
    useCarregamentoPagina(gerando);

    const gerar = fichaFinal => () => {
        createFile(`${URL_INSCRICOES_ARQUIVOS_FICHA(inscricao.id)}?final=${fichaFinal}`, CORPO, response => {
            salvarArquivoResposta(response, 'ficha-inscricao.pdf');
            onClose();
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            classes={{paper: classes.root}}
            scroll='body'
            aria-labelledby='dialog-ficha-inscricao-titulo'>
            <DialogTitle id='dialog-ficha-inscricao-titulo'>Emissão da Ficha de Inscrição</DialogTitle>
            <DialogContent>
                <Typography variant='body1'>
                    Esta é a ficha final/concluída? Somente a ficha final apresenta o parecer da supervisora ao término do documento.
                </Typography>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>Fechar</TextButton>
                <OutlinedButton startIcon={<DescriptionOutlined/>} disabled={gerando} onClick={gerar(false)}>
                    Não
                </OutlinedButton>
                <ContainedButton startIcon={<CheckOutlined/>} disabled={gerando} onClick={gerar(true)}>
                    Sim, ficha final
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}

DialogFichaInscricao.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    /* Inscrição da linha: {id}. */
    inscricao: PropTypes.shape({id: PropTypes.number})
};
